sew-ws-tooltip {
    --link-color: #fff;

    display: inline-block;
    position: relative;
    vertical-align: text-bottom;

    .info-icon {
        color: $color-red;
    }

    &::after {
        border-color: $color-grey-01-dark transparent;
        border-style: solid;
        border-width: 0 16px 16px;
        content: '';
        left: -4px;
        padding-top: 4px;
        position: absolute;
        width: 0;
        z-index: 1;
    }

    .tooltip {
        background-color: $color-grey-01-dark;
        box-sizing: border-box;
        color: $color-white;
        left: 50%;
        padding: 24px 32px 32px;
        position: absolute;
        top: 44px;
        transform: translateX(-50%);
        width: 100%;
        z-index: 1;
    }

    p {
        @include typo-ws-paragraph-bold;

        margin: 0;
    }

    sew-ws-linklist {
        --link-color: #{$color-white};

        margin-top: 16px;
    }

    a {
        text-decoration: underline !important;
    }

    sew-ws-link,
    sew-ws-button {
        a {
            text-decoration: none !important;
        }
    }

    &.--hide {
        &::after,
        .tooltip {
            display: none;
        }
    }

    &.has-target {
        &::after {
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
        }

        .tooltip {
            top: calc(100% + 20px);
        }
    }
}

@include mq-2-min {
    sew-ws-tooltip {
        .tooltip {
            width: 360px !important;
        }
    }
}

@include mq-1 {
    sew-ws-tooltip {
        .tooltip {
            padding: 24px 20px;
        }
    }
}
